import { createWidget } from '@alfa-bank/site-util-create-widget';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import { isSuccess } from '@alfa-bank/site-form-helpers/meta/is-success';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { BaseSelect as Select } from '@alfa-bank/site-form-utils/components/base-select';

import { AddressRegistrationInput as Component } from './address-registration';
import type { IDeps, TAddressRegistrationInput } from './models';

// eslint-disable-next-line styler/check-styler
export const AddressRegistrationInput = createWidget<IDeps, TAddressRegistrationInput>({
    Select,
    getCaption,
    isSuccess,
    isError,
})(Component);
